import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { axiosGet, axiosPost } from "../../services/axiosService";
import { userSlice } from "../../redux/User";

export default function UseTemplate() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [status, setStatus] = useState<"loading" | "error">("loading");
  const [error, setError] = useState("");
  const cloneStarted = useRef(false);

  const botURL = searchParams.get("botURL");

  useEffect(() => {
    if (!botURL) {
      navigate("/templates");
      return;
    }

    // Prevent double-trigger on re-renders / back navigation
    if (cloneStarted.current) return;
    cloneStarted.current = true;

    axiosGet(`/users/templateBot?botURL=${botURL}`)
      .then((response: any) => {
        const { projectName, botCustomId } = response.data.data;
        axiosPost("/audience/lists", {
          name: projectName,
          list_id: botCustomId,
          type: "bot",
        }).catch(() => {
          console.warn(
            "Failed to create audience list for template — template still works.",
          );
        });
        // Navigate to the AI workflow builder (consistent with Templates.tsx)
        navigate(`/text-to-workflow/${botCustomId}`, { replace: true });
      })
      .catch((err) => {
        cloneStarted.current = false;
        setStatus("error");
        setError(err.response?.data?.message || "Failed to clone template");
        dispatch(
          userSlice.actions.setInfoModal({
            showModal: true,
            modalType: "error",
            modalTitle: "Error",
            modalMessage:
              err.response?.data?.message ||
              "Failed to clone template. Please try again.",
          }),
        );
      });
  }, [botURL]);

  if (status === "loading") {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          gap: "16px",
        }}
      >
        <div className="loader" />
        <p style={{ color: "#64748b", fontSize: 15 }}>
          Setting up your template...
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: "16px",
      }}
    >
      <div style={{ fontSize: 40, marginBottom: 4 }}>😕</div>
      <p style={{ color: "#334155", fontSize: 16, fontWeight: 500 }}>
        Something went wrong
      </p>
      <p
        style={{
          color: "#94a3b8",
          fontSize: 13,
          maxWidth: 400,
          textAlign: "center",
        }}
      >
        {error}
      </p>
      <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
        <button
          onClick={() => {
            cloneStarted.current = false;
            setStatus("loading");
            setError("");
          }}
          style={{
            padding: "10px 24px",
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 600,
            background: "#f3f4f6",
            border: "none",
            color: "#334155",
            cursor: "pointer",
          }}
        >
          Retry
        </button>
        <button
          onClick={() => navigate("/templates")}
          style={{
            padding: "10px 24px",
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 600,
            background: "#fb5f66",
            border: "none",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Back to Templates
        </button>
      </div>
    </div>
  );
}
